module.exports = __webpack_public_path__ + "static/oprah-winfrey-41bdb67fcc0a59effd091b664f9afdd4.jpg";